import RaterPriceClientProductCapitalized from '@/modules/common/common/models/MID/RaterPriceClientProductCapitalized'
import PetsRaterPriceInsuredToSave from '@/modules/pets/common/models/MID/PetsRaterPriceInsuredToSave'

export default class PetsRaterPriceRequest {
  /** Lista de productos del cliente. (Opcional). */
  clientProducts: RaterPriceClientProductCapitalized[]

  /** Línea de negocio. Ejemplo: "MA01". (Obligatorio, String). */
  businessLine: string

  /** Fecha de inicio de seguro. Ejemplo: "2024-09-24". (Obligatorio, DateTime). */
  insuranceStartDate: string

  /**  Listado de asegurados. (Obligatorio).  */
  insureds: PetsRaterPriceInsuredToSave[]

  /** Número de cotización. Ejemplo: "7747027". (Opcional, String). */
  quotationNumber: string | undefined

  /** Código de identificación de la cotización. Ejemplo: "27B3A7EA-876D-440D-9F53-3A16F7CD0226". (Opcional, GUID). */
  quotationId: string | undefined

  /** Si debe dejar registro en Senda o no */
  isQuote: boolean = false

  /** (String, opcional): Código del mediador. */
  mediator?: string

  constructor(data: any) {
    this.clientProducts = data.clientProducts?.map(
      (c: any) => new RaterPriceClientProductCapitalized(c)
    )
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insureds = data.insureds?.map((i: any) => new PetsRaterPriceInsuredToSave(i))
    this.quotationNumber = data.quotationNumber
    this.quotationId = data.quotationId
    this.isQuote = data.isQuote
    if (data.mediator) this.mediator = data.mediator
  }
}
